import { render } from "./CreateNewUser.vue?vue&type=template&id=04d96ffa"
import script from "./CreateNewUser.vue?vue&type=script&lang=js"
export * from "./CreateNewUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__